import { render, staticRenderFns } from "./GeneralInstructions.vue?vue&type=template&id=5c0b80e4"
import script from "./GeneralInstructions.vue?vue&type=script&lang=js"
export * from "./GeneralInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports